import React from 'react';

export default ({ value }) => <>{value ? 'Sì' : 'No'}</>;
